import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-tables-content',
  templateUrl: './home-tables-content.component.html',
  styleUrls: ['./home-tables-content.component.css']
})
export class HomeTablesContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
